<div class="header-container d-flex fd-row jc-start ai-center">
  <button mat-icon-button (click)="toggle()" class="menu-button" *ngIf="showMenuButton">
    <mat-icon>menu</mat-icon>
  </button>
  <div *ngIf="!showMenuButton" class="spacer"></div>

  <ng-content select="[headerLeft]"></ng-content>

  <suvo-core-breadcrumbs
    class="flex-1"
    [showBackButton]="showBreadcrumbBackButton"
    [disableFirstBreadcrumbLink]="disableFirstBreadcrumbLink"
  ></suvo-core-breadcrumbs>
  <suvo-bi-favourite-item-star></suvo-bi-favourite-item-star>

  <ng-content select="[headerRight]"></ng-content>
</div>
